import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { STATION_REQUESTS_COLUMNS, STATION_REQUESTS_TABLE_MIN_WIDTH } from './StationRequestsTable';

export const StationRequestsTableSkeleton = memo(function StationRequestsTableSkeleton() {
  return <DataTableSkeleton columns={STATION_REQUESTS_COLUMNS} rows={8} minWidth={STATION_REQUESTS_TABLE_MIN_WIDTH} dense />;
});

export default StationRequestsTableSkeleton;
